import React from "react";
import { renderToString } from "react-dom/server";
import PropTypes from "prop-types";
import cn from "classnames";
import Image from "common/components/image";
import { MKT_CREATIVES_COUNT } from "common/variables";

const WHY_ITEMS = [
  {
    title: "Real talent, authentic results",
    description: renderToString(
      <span>
        {MKT_CREATIVES_COUNT} skilled and vetted designers
        <br className="show-for-large" /> dedicated to bringing your brand to
        life.
      </span>
    ),
    image:
      "https://crowdspring3-assets.s3.amazonaws.com/marketing/why-talent-2.png",
  },
  {
    title: "Support: always here, always ready",
    description: renderToString(
      <span>
        Reach out anytime - our award-winning team
        <br className="show-for-large" /> of support superheroes is here for you
        via
        <br className="show-for-large" /> phone, email, or chat.
      </span>
    ),
    image:
      "https://crowdspring3-assets.s3.amazonaws.com/marketing/why-support-2.png",
  },
  {
    title: "Satisfaction 100% guaranteed",
    description: renderToString(
      <span>
        If you're not 100% happy with your design
        <br className="show-for-large" /> project, you get your money back. No
        <br className="show-for-large" /> questions asked.
      </span>
    ),
    image:
      "https://crowdspring3-assets.s3.amazonaws.com/marketing/why-guarantee-2.png",
  },
  {
    title: "World-class IP protections",
    description: renderToString(
      <span>
        Custom written contracts and full ownership
        <br className="show-for-large" /> of your design. We set the standard in
        <br className="show-for-large" /> Intellectual property protection.
      </span>
    ),
    image:
      "https://crowdspring3-assets.s3.amazonaws.com/marketing/why-ip-protection-2.png",
  },
];

const Why2 = ({ background, title, items }) => {
  return (
    <section className={cn("block block-why-2", background)}>
      <div className="row columns">
        <div className="block-header">
          <h2>{title || "Why choose crowdspring"}</h2>
        </div>
      </div>
      <div className="row small-up-1 medium-up-2">
        {(items || WHY_ITEMS).map((item, i) => (
          <div className="column item" key={i}>
            <div className="row small-gutter">
              <div className="column small-gutter small-3">
                <Image src={item.image} alt={item.title} />
              </div>
              <div className="column small-gutter small-13">
                <h4>{item.title}</h4>
                <p dangerouslySetInnerHTML={{ __html: item.description }} />
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

Why2.propTypes = {
  background: PropTypes.string,
  title: PropTypes.string,
  items: PropTypes.array,
};

export default Why2;
